/**
 * 工具类
 */
export default {
  // 节流阀
  throttle (callBack, time) {
    let timer = null
    return function() {
      if (!timer) {
        timer = setTimeout(() => {
          callBack()
          timer = null
        }, time)
      }
    }
  },
  // 日期格式化
  dateFormat (value) {
    if (value) {
      let add0 = (m) => {
        return m < 10 ? '0' + m : m
      }
      var time = new Date(value)
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      var h = time.getHours()
      var mm = time.getMinutes()
      var s = time.getSeconds()
      return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
    } else {
      return ''
    }
  },
}